﻿import controller from '../../../../resources/scripts/_shared/controller';

function startpageserviceinformation(context) {
  const dismissButton = context.querySelector('.aimo-service-messages__dismiss');

  function init() {
    if(sessionStorage.getItem('aimopark_serviceinformation'))
        return;

    context.classList.add('aimo-service-messages--visible');

    dismissButton.addEventListener('click', function() {
      sessionStorage.setItem('aimopark_serviceinformation', '1');
      context.style.marginTop = `-${context.offsetHeight}px`;
      event.preventDefault();
    });
  }

  return {
    init
  };
}

controller.add('startpage-serviceinformation', startpageserviceinformation);